import React, { useEffect, useRef, useState } from "react";
import debounce from "lodash/debounce";
import { isSafari } from "@/utils/isSafari";

type SlopeProps = React.HTMLAttributes<HTMLDivElement>;

const Slope: React.FC<SlopeProps> = (props) => {
  const [height, setHeight] = useState<number | string>("100%");
  const [width, setWidth] = useState<number | string>("100%");
  const containerRef = useRef<HTMLDivElement>(null);

  // Older versions of Safari don't play nice with percentage sizes for SVGs.
  // This resize logic can be removed once Safari 15.4 is fully supported.
  useEffect(() => {
    function handleResize() {
      if (containerRef.current !== null) {
        setHeight(containerRef.current.offsetHeight);
        setWidth(containerRef.current.offsetWidth);
      }
    }

    // Debounce to ensure the function is only called a maximum of once per second
    const debouncedHandleResize = debounce(handleResize, 1000);

    if (isSafari(navigator.userAgent)) {
      // Resize once on load, then for every resize
      handleResize();
      window.addEventListener("resize", debouncedHandleResize);
    }

    // Cleanup on unmount
    return () => {
      window.removeEventListener("resize", debouncedHandleResize);
    };
  }, []);

  return (
    <div ref={containerRef} {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 100 90"
        preserveAspectRatio="none"
        focusable="false"
        aria-hidden="true"
      >
        <path fill="currentColor" d="M-1-1-1 92 100-1" />
      </svg>
    </div>
  );
};

export default Slope;
